import React, { useState, useEffect } from "react";
import { Editor, EditorState, convertFromRaw } from "draft-js";
import "draft-js/dist/Draft.css";

const CreateTableRichText = (props) => {
  const { field } = props;

  const calcStates = (value) => {
    const state = [];
    /*replace udwaspas with " for rich text Editor*/
    const transformedValue = value.replaceAll("udwaspas", '"');
    let value_ = transformedValue;
    if (transformedValue) {
      const initialState = {
        blocks: [
          {
            key: "a9erb",
            text: "",
            type: "unstyled",
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {},
          },
        ],
        entityMap: {},
      };
      if (!transformedValue.includes('{"blocks":[{"key":')) {
        initialState.blocks[0].text = value;
        value_ = JSON.stringify(initialState);
      }
      try {
        //find if more than one richtext, could be concatenated
        const count = (value_.match(/{"blocks":/g) || []).length;
        const start = '{"blocks":';
        const end = ',"entityMap":{}}';
        let str = value_;

        for (let i = 0; i < count; i++) {
          for (let j = 0; j < i; j++) {
            str = str.slice(str.indexOf(end) + 16);
          }
          //extract editor blocks
          const startIndex = str.indexOf(start);
          const endIndex = str.indexOf(end);

          //find text before editor
          const extraTextBlock = str.slice(0, startIndex);
          if (extraTextBlock) {
            state.push({ textBlock: extraTextBlock });
          }

          const newStr = str.slice(startIndex, endIndex) + end;
          //console.log("str and index", i, str);
          //console.log("sliced", newStr);
          state.push(
            EditorState.createWithContent(convertFromRaw(JSON.parse(newStr)))
          );
        }
      } catch (e) {
        console.log(e);
        state.push(EditorState.createEmpty());
      }
    } else {
      state.push(EditorState.createEmpty());
    }
    return state;
  };

  const [editorStates, setEditorStates] = useState(calcStates(field));

  useEffect(() => {
    setEditorStates(calcStates(field));
  }, [field]);

  return (
    <div>
      {editorStates.map((state, index) =>
        state.textBlock ? (
          <div key={index}>{state.textBlock}</div>
        ) : (
          <Editor key={index} editorState={state} readOnly />
        )
      )}
    </div>
  );
};
export default CreateTableRichText;
